export default __webpack_public_path__ + "static/media/mojeID.046c2083.svg";